import React from 'react';

import { ADMIN_DASHBOARD, ADMIN_PENDING_HIRES } from '@ApplicationWide/permissions/constants';
import { ONBOARD_PATH } from '@ApplicationWide/routes/admin/admin-urls';

const AddNewHirePage = React.lazy(() => import('../../../pages/Admin/PendingHires/Onboarding/AddNewHirePage'));

export default {
  route: [ONBOARD_PATH, `${ONBOARD_PATH}/:userId`],
  area: ADMIN_PENDING_HIRES,
  component: AddNewHirePage,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DASHBOARD,
  hasNavBar: true,
};
